import SpriteFlowerObject from './SpriteFlowerObject'
import GlbFlowerObject from './GlbFlowerObject'

let flowerSequence = 0;

class FlowerObject {
    constructor(initData) {
        // Cached resources can create several flowers in the same millisecond.
        const flowerData = {
            ...initData,
            id: initData.id || `flower_${Date.now()}_${++flowerSequence}`
        };
        const resource = initData.resource || {};
        const renderType = resource.resourceRenderType || (resource.detail && resource.detail.format === 'glb' ? 'glb' : 'sprite');
        if (renderType === 'glb') {
            return new GlbFlowerObject(flowerData);
        }
        return new SpriteFlowerObject(flowerData);
    }
}

export default FlowerObject;
